import { generateId } from '@freelancer/datastore/testing/helpers';
import type { ContestEntryJudgeAssignment } from './contest-entry-judge-assignments.model';

export interface GenerateContestEntryJudgeAssignmentOptions {
  readonly id?: number;
  readonly entryId?: number;
  readonly userId?: number;
  readonly contestId?: number;
  readonly timeCreated?: number;
}

export function generateContestEntryJudgeAssignmentObject({
  id = generateId(),
  entryId = generateId(),
  userId = generateId(),
  contestId = generateId(),
  timeCreated = Date.now(),
}: GenerateContestEntryJudgeAssignmentOptions): ContestEntryJudgeAssignment {
  return {
    id,
    entryId,
    userId,
    contestId,
    timeCreated,
  };
}
